import { Route } from "@angular/router";
import { EditarPerfilPage } from "./editar-perfil.page";

export const EditarPerfilRouter: Route[] = [
  { path: 'editar-perfil', component: EditarPerfilPage }
];
